<div class="left-panel-container">
  
  <!-- Left panel content -->
  <div class="left-panel-content" [style.display]="getVisible()" [ngClass]="isleftPanelVisibale? '--expanded' : ''">

    <!-- heading -->
    <div class="left-panel-heading">
      {{"lbl_family_details_of" | translate}} <br/>
      {{title}}
    </div>
    <!-- content controller -->
    <div class="left-panel-scroll border-outline pr-1">
    <div>
      <!-- married families heading -->
      <div class="family-heading justify-content-between">
        <div class="label-l-grey-bold" style="cursor: pointer;" (click)="toggleRelationship()">{{"lbl_relationships" | translate}}</div>
        <div class="default-icon-wrapper custom-cursor-pointer" (click)="toggleRelationship()">
          <i *ngIf="marriedFamilies.length > 0 && isSpousePanelExpanded" class="fa fa-caret-down"></i>
          <i *ngIf="marriedFamilies.length > 0 && !isSpousePanelExpanded" class="fa fa-caret-up"></i>
        </div>
      </div>
      
      <!-- married family list -->  
      <div  *ngIf="marriedFamilies.length && animationsReady" [@expandCollapse]="isSpousePanelExpanded ? 'expanded' : 'collapsed'" class="married-fam-area">
        <!-- wife 1 family -->
          <div *ngFor="let mfamily of marriedFamilies" style="margin-right: 10px">  
            <div class="family-container justify-content-between" *ngIf="mfamily.spouse != undefined && (mfamily.spouse.displayName || mfamily.children?.length > 0)">
              <!-- drop- menu -->
              <div class="drop-menu-wrapper">
                <app-drop-menu [menu]="getSpouseFamilyDropMenu(mfamily)" (action)="handleFamilyMenuAction($event, mfamily)"></app-drop-menu>
              </div>
                  
              <div class="profile-container line-gradient-bottom">
                <span (click)="changeRootMember(mfamily.spouse)" class="text-ellipsis-2" [ngClass]="['label-l-'+mfamily.spouse.gender , !mfamily.spouse.displayName ? 'placeholder-text-l' : '', mfamily.spouse.id == 0 ? 'cursor-default' : '']">{{mfamily.spouse.displayName || undefinedText }}</span>
                <div class="label-s-relationship">({{mfamily.spouse.relationToRootMember}}) </div>
              </div>

              <!-- EM-19171 added dropdown icon for spouses -->
              <div style="position: relative;margin-left: auto;">
                <div *ngIf="mfamily?.children?.length > 0 && isSopuseExpanded[mfamily.familyId]" class="default-icon-wrapper custom-cursor-pointer" (click)="toggleSpouse(mfamily.familyId)">
                  <i class="fa fa-angle-down"></i>
                </div>
                <div *ngIf="mfamily?.children?.length > 0 && !isSopuseExpanded[mfamily.familyId]" class="default-icon-wrapper custom-cursor-pointer" (click)="toggleSpouse(mfamily.familyId)">
                  <i class="fa fa-angle-up"></i>
                </div>
              </div>

            </div>        
            <!-- child1 -->
            <div class="mb-2" [@expandCollapse]="isSopuseExpanded[mfamily.familyId] ? 'expanded' : 'collapsed'">
               <div class="child1-wrapper" *ngFor="let childfamily of mfamily.children">
                 <div class="profile-container-level1" *ngIf="childfamily.individual.show">
                   <div class="info-container">
                     <span (click)="changeRootMember(childfamily.individual)" class="text-ellipsis-2" [ngClass]="'label-m-'+childfamily.individual.gender">{{childfamily.individual.displayName}}</span>
                     <div class="label-s-relationship">({{childfamily.individual.relationToRootMember}})</div>
                   </div>
                 </div>
                 <!-- child1 wife -->
                 <div>
                   <div class="profile-container-level1 child-fam" *ngIf="childfamily.spouse != undefined && (childfamily.spouse.displayName || childfamily.children?.length > 0)">
                     <div class="drop-menu-wrapper">
                      <app-drop-menu [menu]="getSpouseFamilyDropMenu(childfamily)" (action)="handleFamilyMenuAction($event, childfamily)"></app-drop-menu>
                    </div>
                     <div id="wife" class="info-container" >                  
                       <span (click)="changeRootMember(childfamily.spouse)" class="text-ellipsis-2" [ngClass]="['label-m-'+childfamily.spouse.gender, !childfamily.spouse.displayName ? 'placeholder-text-m' : '', childfamily.spouse.id == 0 ? 'cursor-default' : '']">{{childfamily.spouse.displayName || undefinedText}}</span>
                       <div class="label-s-relationship">({{childfamily.spouse.relationToRootMember}})</div>
                     </div>
                   </div>

                  <div class="grand-fam">
                    <div *ngFor="let grandChildfamily of childfamily.children" class="info-container" style="padding-left:28px;">
                      <span (click)="changeRootMember(grandChildfamily.individual)" class="text-ellipsis-2"
                        [ngClass]="'label-m-'+grandChildfamily.individual.gender">{{grandChildfamily.individual.displayName}}</span>
                      <div class="label-s-relationship">({{grandChildfamily.individual.relationToRootMember}}) </div>
                    </div>
                  </div>
               </div>

             </div>
          </div>
        </div>        
      </div>

      <!-- Parents heading -->
      <div class="family-heading heading-top justify-content-between">
        <div class="label-l-grey-bold" style="cursor: pointer;" (click)="isParentPanelExpanded = !isParentPanelExpanded">{{"lbl_parents" | translate}}</div>
        <div class="default-icon-wrapper custom-cursor-pointer" (click)="isParentPanelExpanded = !isParentPanelExpanded">
          <i *ngIf="parentFamilies.length > 0 && isParentPanelExpanded"  class="fa fa-caret-down"></i>
          <i *ngIf="parentFamilies.length > 0 && !isParentPanelExpanded"  class="fa fa-caret-up"></i>
        </div>
      </div>
      <!-- parent list -->
      <div  *ngIf="parentFamilies.length && animationsReady" class="overflow-hidden" [@expandCollapse]="isParentPanelExpanded ? 'expanded' : 'collapsed'">
        <span></span>
        <div class="parent-list-wrapper" *ngFor="let pfamily of parentFamilies">
          <div class="parent-list profile-container-level1" >

            <div class="drop-menu-wrapper">
                <app-drop-menu [menu]="getParentFamilyDropMenu(pfamily)" (action)="handleFamilyMenuAction($event, pfamily)"></app-drop-menu>
            </div>
            
            <div class="info-container">
              <div (click)="changeRootMember(pfamily.individual)" class="text-ellipsis-2" [ngClass]="'label-l-'+pfamily.individual.gender">{{pfamily.individual.displayName}}</div>
              <div class="label-s-relationship">({{pfamily.individual.relationToRootMember}})</div>
            </div>
          </div>
          <!-- child1 wife -->
          <div class="parent-list-level-02 mr-2" style="margin-left: 38px;" *ngIf="pfamily.spouse != undefined">
            <div class="parent-list-level-02__wife" id="wife">
              <div (click)="changeRootMember(pfamily.spouse)" class="text-ellipsis-2" [ngClass]="'label-m-'+pfamily.spouse.gender">{{pfamily.spouse.displayName}}</div>
              <div class="label-s-relationship">({{pfamily.spouse.relationToRootMember}})</div>
            </div>
            <div class="parent-list-level-02__child" *ngFor="let child of pfamily.children">
              <div (click)="changeRootMember(child.individual)" class="text-ellipsis-2" [ngClass]="'label-s-'+child.individual.gender">{{child.individual.displayName}} 
              <span *ngIf="child.relationshipType > 1">
                ({{child.individual.childRelation}})
              </span>  
              </div>
              <div class="label-s-relationship">({{child.individual.relationToRootMember}})</div>
            </div>  
          </div>                        
        </div> 
      </div>  
    </div>    
    </div>
  </div>
  <!-- Left panel control buttons -->
  <div class="left-panel-control">
    <div class="left-panel-buttons">
      <img class="element-over-hand btn-sider-inner" (click)="toggle()" [hidden]="!isleftPanelVisibale"
        src="assets/tree-editor/left_pane/btn_left_pane_closed.svg" style="display: block;" />
      <img class="element-over-hand btn-sider-outside" (click)="toggle()" [hidden]="isleftPanelVisibale"
        src="assets/tree-editor/left_pane/btn_left_pane_closed.svg" style="display: block;" />
    </div>
  </div>
</div>